module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [_c('h1', [_vm._v("Active Campaigns")]), _vm._v(" "), _vm._l((_vm.campaigns), function(destination) {
    return _c('div', {
      key: destination.owner,
      staticClass: "col-xs-12 box panel"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('h2', [_vm._v(_vm._s(destination.owner))])]), _vm._v(" "), (_vm.isSalesAgentView) ? _c('div', {
      staticClass: "panel-body"
    }, [_c('table', {
      staticClass: "table table-striped table-hover table-bordered campaigns-table"
    }, [_c('thead', [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Campaigns")])]), _vm._v(" "), _c('tbody', _vm._l((destination.campaigns), function(campaign) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(campaign.name))]), _vm._v(" "), _c('td', [(campaign.campaign_type == 'bookable-appointment') ? _c('router-link', {
        staticClass: "btn btn-primary btn-sm",
        attrs: {
          "to": '/campaign-form/' + campaign.id
        }
      }, [_c('i', {
        staticClass: "fa fa-search"
      }), _vm._v(" Find Appointment")]) : _vm._e()], 1)])
    }), 0)])]) : _vm._l((destination.campaigns), function(campaign) {
      return _c('div', {
        staticClass: "box panel"
      }, [_c('div', {
        staticClass: "panel-body"
      }, [_c('h4', [(campaign.is_test) ? _c('span', {
        staticClass: "label"
      }, [_vm._v("TEST ")]) : _vm._e(), _vm._v(" "), _c('b', [(campaign.campaign_type == 'google') ? _c('span', [_c('i', {
        staticClass: "fa fa-google"
      }), _vm._v(" - ")]) : _vm._e(), _vm._v(" "), (campaign.campaign_type == 'facebook') ? _c('span', [_c('i', {
        staticClass: "fa fa-facebook"
      }), _vm._v(" - ")]) : _vm._e(), _vm._v("\n                " + _vm._s(campaign.name) + "\n              ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(campaign.description))]), _vm._v(" "), (campaign.campaign_type == 'bookable-appointment') ? _c('h5', [_vm._v("Actions")]) : _vm._e(), _vm._v(" "), _c('p', [(campaign.campaign_type == 'bookable-appointment') ? _c('router-link', {
        staticClass: "btn btn-primary",
        attrs: {
          "to": '/campaign-form/' + campaign.id
        }
      }, [_vm._v("Find Appointment")]) : _vm._e()], 1), _vm._v(" "), _c('p', [(campaign.zipcodes_report_url) ? _c('a', {
        attrs: {
          "href": campaign.zipcodes_report_url,
          "target": "_blank"
        }
      }, [_c('i', {
        staticClass: "fa fa-map"
      }), _vm._v(" Download Zipcodes Report")]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Endpoints")]), _vm._v(" "), _c('table', {
        staticClass: "table table-condensed"
      }, [(campaign.ping_url) ? _c('tr', [_c('th', [_vm._v("Ping")]), _c('td', [_c('code', [_vm._v(_vm._s(campaign.ping_url))])])]) : _vm._e(), _vm._v(" "), (campaign.test_ping_url) ? _c('tr', [_c('th', [_vm._v("Test Ping")]), _c('td', [_c('code', [_vm._v(_vm._s(campaign.test_ping_url))])])]) : _vm._e(), _vm._v(" "), (campaign.inbox_url) ? _c('tr', [_c('th', [_vm._v("Production")]), _c('td', [_c('code', [_vm._v(_vm._s(campaign.inbox_url))])])]) : _vm._e(), _vm._v(" "), (campaign.google_key) ? _c('tr', [_c('th', [_vm._v("Google Key")]), _c('td', [_c('code', [_vm._v(_vm._s(campaign.google_key))])])]) : _vm._e(), _vm._v(" "), (campaign.test_inbox_url) ? _c('tr', [_c('th', [_vm._v("Test")]), _c('td', [_c('code', [_vm._v(_vm._s(campaign.test_inbox_url))])])]) : _vm._e(), _vm._v(" "), (campaign.campaign_type == 'facebook') ? _c('tr', [_c('td', {
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v("This campaign does not use API endpoints")])]) : _vm._e()]), _vm._v(" "), _c('h5', [_vm._v("Fields")]), _vm._v(" "), _c('table', {
        staticClass: "table table-striped"
      }, [_c('thead', [_c('tr', [_c('th', [_vm._v("API Name")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Field Type")]), _vm._v(" "), _c('th', [_vm._v("Format")]), _vm._v(" "), _c('th', [_vm._v("Notes")]), _c('th', [_vm._v("Field Definition")])])]), _vm._v(" "), _c('tbody', _vm._l((campaign.fields.filter(function (f) { return f.field_type !== 'read_only'; })), function(f) {
        return _c('tr', [(f.field) ? [_c('th', {
          staticClass: "align-middle"
        }, [_vm._v(_vm._s(f.alias))]), _vm._v(" "), _c('td', {
          staticClass: "align-middle"
        }, [_c('yes-no', {
          attrs: {
            "ok": f.is_required
          }
        })], 1), _vm._v(" "), _c('td', {
          staticClass: "align-middle"
        }, [_vm._v(_vm._s(f.api_doc.field_type))]), _vm._v(" "), _c('td', {
          staticClass: "align-middle"
        }, [_vm._v(_vm._s(f.api_doc.field_format))]), _vm._v(" "), _c('td', [(f.notes) ? _c('pre', [_vm._v(_vm._s(f.notes))]) : _vm._e()]), _vm._v(" "), _c('td', [(f.field_definition_url) ? _c('a', {
          attrs: {
            "href": f.field_definition_url
          }
        }, [_c('i', {
          staticClass: "fa fa-file"
        }), _vm._v(" Download")]) : _vm._e()])] : _vm._e()], 2)
      }), 0)]), _vm._v(" "), (campaign.capacity && (campaign.capacity.hourly || campaign.capacity.daily || campaign.capacity.weekly || campaign.capacity.monthly)) ? _c('div', {
        staticClass: "col-xs-12"
      }, [_c('h5', [_vm._v("Capacity")]), _vm._v(" "), _c('ul', [(campaign.capacity.hourly) ? _c('li', [_vm._v("Hourly: "), _c('b', [_vm._v(_vm._s(campaign.capacity.hourly))]), _vm._v(" leads")]) : _vm._e(), _vm._v(" "), (campaign.capacity.daily) ? _c('li', [_vm._v("Daily: "), _c('b', [_vm._v(_vm._s(campaign.capacity.daily))]), _vm._v(" leads")]) : _vm._e(), _vm._v(" "), (campaign.capacity.weekly) ? _c('li', [_vm._v("Weekly: "), _c('b', [_vm._v(_vm._s(campaign.capacity.weekly))]), _vm._v(" leads")]) : _vm._e(), _vm._v(" "), (campaign.capacity.monthly) ? _c('li', [_vm._v("Monthly: "), _c('b', [_vm._v(_vm._s(campaign.capacity.monthly))]), _vm._v(" leads")]) : _vm._e()])]) : _vm._e()])])
    })], 2)
  })], 2)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760a194b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/Campaigns.vue
// module id = 684
// module chunks = 0